import React, { Component } from "react";
import "./style.scss";
import classnames from "classnames";
import {
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  Input,
  Label,
} from "reactstrap";
import { DocumentUploadViewTab } from "./DocumentUploadViewTab";
import { withTranslation } from "react-i18next";
import { DocumentUpload } from "component/Admin/Backend/Outlet master/DocumentUpload";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  commonCreateApi,
  commonUpdateApi,
  getCommonApi,
} from "redux/actions/common";
import { SignPanel } from "component/common/SignPanel";
import SignaturePad from "react-signature-canvas";

class MCFormPopupClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientName: "",
      treatmentName: "",
      patientGender: "",
      visitDate: "",
      treatmentFrom: "",
      treatmentTo: "",
      // restrictionDetails: "",
      yourRef: "",
      date: "",
      ourRef: "",
      signatureImageData: null,
      formData: {
        headerData: null,
        outletDetails: null,
      },
      today: new Date().toISOString().split("T")[0],
    };
  }

  componentDidMount() {
    this.fetchFormData();
    this.fetCustomerDetails();
  }

  fetCustomerDetails = () => {
    let { customerDetail } = this.props;
    let { patientName, patientGender, visitDate, yourRef, ourRef } = this.state;
    if (customerDetail) {
      patientName = customerDetail?.cust_name;
      patientGender = customerDetail?.Cust_sexesid === 1 ? "Male" : "Female";
      yourRef = customerDetail?.lastinvoicenumber;
      visitDate = customerDetail?.lastvistdate?.split(" ")[0] || "";
      ourRef = customerDetail?.mc_number;
      this.setState({
        patientGender,
        patientName,
        yourRef,
        visitDate,
        ourRef,
      });
    }
  };
  fetchFormData = async () => {
    try {
      this.props.getCommonApi("title").then((res) => {
        const mockHeaderData = {
          clinicName: res?.data?.dataList[0]?.trans_h1,
          address: res?.data?.dataList[0]?.trans_h1,
          logo: res?.data?.dataList[0]?.logo_pic,
        };

        const mockOutletData = {};

        this.setState({
          formData: {
            headerData: mockHeaderData,
            outletDetails: mockOutletData,
          },
        });
      });
    } catch (error) {
      console.error("Error fetching form data:", error);
    }
  };

  handleInputChange = (field, value) => {
    this.setState({ [field]: value });
  };

  dataURLtoFile = (dataUrl, filename) => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  handleSignSaveClick = (imgData) => {
    this.setState({ signatureImageData: imgData });
  };

  handleClearSign = () => {
    this.setState({ signatureImageData: null });
  };

  handleSubmit = () => {
    const {
      patientName,
      patientGender,
      visitDate,
      treatmentFrom,
      treatmentTo,
      restrictionDetails,
      yourRef,
      ourRef,
      treatmentName,
    } = this.state;

    const formData = new FormData();
    formData.append("patient_name", patientName);
    formData.append("treatment_name", treatmentName);
    formData.append("visit_date", visitDate);
    formData.append("treatment_start_date", treatmentFrom);
    formData.append("treatment_end_date", treatmentTo);
    formData.append("your_ref", yourRef);
    formData.append("our_ref", ourRef);
    formData.append("cust_code", this.props.id);
    // Capture signature image
    const sigPad = this.sigPad;
    if (sigPad && !sigPad.isEmpty()) {
      const signatureImageData = sigPad
        .getTrimmedCanvas()
        .toDataURL("image/png");
      const file = this.dataURLtoFile(signatureImageData, "signature.png");
      formData.append("signature", file);
    }

    this.props.commonCreateApi(`certificates/`, formData).then((res) => {
      console.log("Form submitted", res);
      this.setState({
        treatmentFrom: "",
        treatmentTo: "",
        treatment_name: "",
        patientName: "",
      });
      if (this.sigPad) {
        this.sigPad.clear();
      }
      this.props.toggle();
      this.props.getDocumentDetails();
    });
  };

  handleClearSign = () => {
    if (this.sigPad) {
      this.sigPad.clear();
    }
  };

  render() {
    const { isOpen, toggle, t, customerDetail } = this.props;
    const {
      formData,
      patientName,
      patientGender,
      visitDate,
      treatmentFrom,
      treatmentTo,
      treatmentName,
      today,
    } = this.state;
    console.log(customerDetail, "custDetail");
    console.log(visitDate, "visitDate");
    return (
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
        className="mc-form-modal"
      >
        <ModalBody>
          <div className="mc-form-container">
            {formData.headerData && (
              <div className="mc-header text-center mb-4">
                <Row className="align-items-center">
                  <Col md={2}>
                    <div className="clinic-logo">
                      <div
                        className="logo-placeholder"
                        style={{
                          width: "150px",
                          minHeight: "80px",
                          background: "#f0f0f0",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "12px",
                          color: "#666",
                        }}
                      >
                        <img src={formData.headerData.logo} alt="logo" />
                      </div>
                    </div>
                  </Col>
                  <Col md={9}>
                    <div className="clinic-details">
                      <h4 className="clinic-name mb-2">
                        {formData.headerData.clinicName}
                      </h4>
                      <p className="clinic-address mb-1">
                        {formData.headerData.address}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            <hr />

            <div className="form-content">
              <h5 className="text-center mb-4">TO WHOM IT MAY CONCERN</h5>

              <Row className="mb-3">
                <Col md={3}>
                  <Label>Your Ref:</Label>
                </Col>
                <Col md={3}>
                  <Input
                    type="text"
                    name="yourRef"
                    value={this.state.yourRef}
                    onChange={(e) =>
                      this.handleInputChange("yourRef", e.target.value)
                    }
                  />
                </Col>
                <Col md={3} className="d-flex align-items-center">
                  <Label>Date:</Label>
                </Col>
                <Col md={3}>
                  <Input type="date" name="date" disabled value={today} />
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={3}>
                  <Label>Our Ref:</Label>
                </Col>
                <Col md={9}>
                  <Input
                    type="text"
                    name="ourRef"
                    value={this.state.ourRef}
                    onChange={(e) =>
                      this.handleInputChange("ourRef", e.target.value)
                    }
                  />
                </Col>
              </Row>

              <div className="form-text mb-4">
                <p>Please be advised that Mr/Mdm/Ms</p>
                <Input
                  type="text"
                  value={patientName}
                  onChange={(e) =>
                    this.handleInputChange("patientName", e.target.value)
                  }
                  placeholder="Patient Name"
                  className="inline-input mb-2"
                />

                <Row className="mb-3">
                  <Col md={6}>
                    <Label>Treatment Name</Label>
                    <Input
                      type="text"
                      value={treatmentName}
                      onChange={(e) =>
                        this.handleInputChange("treatmentName", e.target.value)
                      }
                      placeholder="Treatment Name"
                      className="inline-input mb-2"
                    />
                  </Col>
                  <Col md={6}>
                    <Label>Visit Date</Label>
                    <Input
                      type="date"
                      value={visitDate}
                      onChange={(e) =>
                        this.handleInputChange("visitDate", e.target.value)
                      }
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md={6}>
                    <Label>Treatment From</Label>
                    <Input
                      type="date"
                      value={treatmentFrom}
                      onChange={(e) =>
                        this.handleInputChange("treatmentFrom", e.target.value)
                      }
                    />
                  </Col>
                  <Col md={6}>
                    <Label>To</Label>
                    <Input
                      type="date"
                      value={treatmentTo}
                      onChange={(e) =>
                        this.handleInputChange("treatmentTo", e.target.value)
                      }
                    />
                  </Col>
                </Row>

                {/* <Row className="mb-3">
                  <Col md={12}>
                    <Label>Restriction Details</Label>
                    <Input
                      type="textarea"
                      value={restrictionDetails}
                      onChange={(e) =>
                        this.handleInputChange(
                          "restrictionDetails",
                          e.target.value
                        )
                      }
                    />
                  </Col>
                </Row> */}
                <p className="mb-3">
                  In this period of recuperation he/she is not suitable to do
                  labourous or sternuous exercise.
                </p>
                <p className="mb-3">Your cooperation will be appreciated.</p>
                <p className="mb-3">Thank You.</p>
                <p className="mb-4">Yours Truly</p>
              </div>

              <Row className="signature-section mt-4">
                <Col md={4}>
                  <SignaturePad
                    canvasProps={{
                      className: "border sigPad w-100",
                      width: 300,
                      height: 150,
                    }}
                    ref={(ref) => {
                      this.sigPad = ref;
                    }}
                  />
                  <div className="signature-line mt-3">
                    <hr style={{ width: "100%", margin: "0" }} />
                    <p className="mt-2">Registered TCM Physician</p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.handleSubmit}>
            {t("Submit")}
          </Button>
          <Button color="secondary" onClick={toggle}>
            {t("Cancel")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  appointmentDetail: state.appointment.appointmentDetail,
  tokenDetails: state.authStore.tokenDetails,
  transactionSettingList: state.transactionStore.transactionSettingList,
  transactionOrderChangeList: state.transactionStore.transactionOrderChangeList,
  customerDetail: state.customer.customerDetail,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCommonApi,
      commonCreateApi,
      commonUpdateApi,
    },
    dispatch
  );

export const MCFormPopup = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(MCFormPopupClass));